import tempMeeApi from '../../../apis/tempMee';

// Returns 409 when the application window overlaps an existing cycle's —
// enforced by a Postgres exclusion constraint, not just an app-level check.
export const createCycle = async (payload) => {
  const response = await tempMeeApi.post(
    '/awards-service-api/admin/cycles',
    payload,
  );

  return response.data;
};
